import { BaseModel } from '../../shared/base/base.models';

export class DocumentStorage extends BaseModel {
    code?: string;
    type?: DocumentStorageType | string;
    name?: string;
}

export enum DocumentStorageType {
    PRODUCT, BADGE, PRODUCT_CATEGORY, COUNTRY
}